#import "../fragments/audience-engagement-stats-fragment.graphql"

query GetAudienceEngagementStats($audienceId: ID!) {
    audience(id: $audienceId) {
        ...AudienceEngagementStats
    }
}
